import { IsBoolean, IsOptional } from 'class-validator';
import { NamedEntityDto } from './named.dto';

export class RiskFactorDto extends NamedEntityDto {
  @IsOptional()
  @IsBoolean()
  requireDescription?: boolean;
}
